import { render, staticRenderFns } from "./LoadableIframe.vue?vue&type=template&id=99ef0d44&scoped=true&"
import script from "./LoadableIframe.vue?vue&type=script&lang=js&"
export * from "./LoadableIframe.vue?vue&type=script&lang=js&"
import style0 from "./LoadableIframe.vue?vue&type=style&index=0&id=99ef0d44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ef0d44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VProgressCircular,VRow})
